import React from "react";
import style from "./block.module.scss";
import logo from "./logoSetC2.png";
import mail from "./mail.svg";
import phone from "./phone.svg";
import location from "./location.svg";
import map from "./Composant.svg";

export default function Header({custom_settings}) {
    return <div className={style.block}>
        <div className={style.content}>
            <div className={style.title}>CONTACT</div>
            <div className={style.bar} />
            <div className={style.footer}>
                <div className={style.logo}>
                    <div><img src={logo} alt="sens et croissance" /></div>
                    <div className={style.text}>Centre de formation et de recherche<br/> sur l'éthique professionnelle,<br/> le management et la responsabilité<br/> sociale de l'entreprise.</div>
                </div>
                    <div className={style.infos}>
                        <div className={style.col}>
                            <div className={style.contact}>
                                <img src={mail} height="14px" alt="Email" /> {custom_settings["email-contact"]}
                            </div>
                            <div className={style.contact}>
                                <img src={phone} height="18px" alt="Email" /> {custom_settings["phone-number"]}
                            </div>
                        </div>
                        <div className={style.col}>
                                <div className={style.contact}>
                                    <img src={location} height="24px" alt="Email" /> {custom_settings["address"]}
                                </div>
                                <div className={style.contact}>
                                    <img src={map} height="23px" alt="Email" /> <a href={custom_settings["link-download"]} rel="noopener noreferrer" target="_blank">{custom_settings["text-download"]}</a>
                                </div>
                                <div className={style.contact}>
                                    <a className={style.mentions} href={custom_settings["mentions-link"]} >Mentions légales</a>
                                </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>;
}